# Woodworking - Power Tools 101
## 2023/11/24

Finished my intro to woodworking class (specifically power tools) from [Makeville studio](https://makeville.com). I made a small cherry tree side table from scratch featuring bridle joints and a round top. In short, I loved it! Steve, who was my instructor, was very friendly, and the studio itself was really well-furnished and organized. I'd like to write about some of the main tools and techniques I learned during this class.

First of all, this is what I made:

![Powertool 1 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool1.png?raw=true)

This is the photo of the studio:

![Powertool 2 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool2.png?raw=true)


## 1. Milling Lumber
People like to mill rough lumber because it's cheaper and gives them more control over the material. One pro tip from Steve was to use a **chalk** in this process. It was better than a pencil because it's easier to erase and simply nicer to use.

### 1.1 Miter Saw
We used it to cut a large piece of wood into smaller pieces. This is ideal for cross-cutting, which means cutting the wood against the grain direction. This is relatively rough cut so it shouldn't have to be very accurate.

<span style="color:blue">Some Tips</span>
- Do not use the miter saw to cut small pieces.
- We need to position ourselves to the left of the miter saw, and we'll use the board on the left.
- If the lumber is not completely flat, make sure the bow is correct so it doesn't wobble.
- The hand should be on the machine.


### 1.2 Jointer

![Powertool 3 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool3.png?raw=true)

It is a specialized tool that can create smooth, straight edges and flat surfaces in woodworking projects.

<span style="color:blue">Some Tips</span>
- Adjust the depth correctly; you don't want to cut too deep. It's better to make multiple shallow cuts instead (about 3 times).
- Double check the red part is working properly. It has to work.
- Use 2 pushsticks!
- Turn on the dust collector.

### 1.3 Thicknesser

![Powertool 4 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool4.png?raw=true)

It is a tool to trim boards to a consistent thickness throughout their length and flat on both surfaces.

## 2. Table Saw

![Powertool 6 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool6.png?raw=true)

Table saws cut straighter lines and make smoother cuts on small and long boards. It IS dangerous so it's always better to have a "saw stop" attachment. Table saw can do both rip-cut (cutting parallel with the grain direction) & cross-cut. Rip-cut blade is bigger than that of cross-cut. Always be careful with the kickback!

<span style="color:blue">Some Tips</span>
- It could tear the fibers on the bottom part of the wood. Do it more slowly.
- Make sure the blade is upright and square. To check, remove the cover and adjust the angle.
- The edge of the blade shouldn't be significantly higher than the height of the wood; it should be approximately the same height.
- To avoid kickback:
    - Stand close to the left of the machine.
    - Make sure the left hand stays. Don't let go of the board during a cut.
    - Hold the wood when turning on the machine.
    - Make sure the workpiece to not shift into the back of the blade during a cut.
    - Check if the board is not square and flat.

### 2.1 Dado Blades
![Powertool 5 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool5.png?raw=true)

Dado blades allow us to make a cut that is wider than a standard saw blade, converting the table saw into a versatile
tool for creating many types of joinery. In my case, I used these blades to make cross-lap & bridle joints. (2 circles in the above photo)

## 3. Drill Press
It allows us to make holes. Make sure the wood is not wobbly and there's no chip.

<span style="color:blue">Some Tips</span>
- Create a larger, shorter hole initially, and then make a smaller, longer hole so that the screw fits securely.
- Wood will crack over time, so avoid using excessive glue as it will lead to cracking. Instead, use a drill press and screws.

## 4. Bandsaw
The bandsaw is a natural choice for cutting curves, but it can also do cross cuts, rip cuts as well as angles and compound shapes. It's very versatile!

<span style="color:blue">Some Tips</span>
- Don't cut all the way to the line. Leave some room so the sander can sand that remaining part.
- You don't have to hold too much. Actually do it faster because otherwise it will burn the wood.
- Don't stop in the middle of the cut.
- Turn on the dust collector.
- To cut a circle, rotate counter-clockwise.  

## 5. Router Table
It was so cool. It is a handheld router mounted upside down in a table. This is to make the best round disk for the tabletop. What we did is attaching the MDF template to the disk I roughly cut from the bandsaw. Then we let the whole thing hit the bearing and rotate. (This is called "pattern routing")

<span style="color:blue">Some Tips</span>
- Similarly, don't hold it too much since it will burn.
- Rotate it counter clockwise again!

## 6. Sander
I used the disk sander. Careful not to touch it.

<span style="color:blue">Some Tips</span>
- Rotate counter-clockwise in the middle to avoid kickback. Rotate the middle part of the disk.
- Don't stay too long because it will burn.
- Use the rubber stick to clean the disk every now and then.

## Overall

![Powertool 7 alt ><](https://github.com/jinnycho/jinnycho.github.io/blob/main/src/assets/photos/powertool7.png?raw=true)

It was a delightful 4 weeks. Waking up early and walking there for 40 minutes in the morning, strolling along Park Slope was truly wholesome. I personally found this more satisfying than the handtools class (which I'd like to cover next time) because it's less exhausting but honestly you need to do both. I'm excited to create more going forward!